import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { ILegacyMigrateRequest, ILegacyMigrateResponse } from '../../../entity/interface/iUserApis';

export interface ILegacyMigrateUseCase {
    execute(
        payload: ILegacyMigrateRequest,
        authToken: string,
        authSign: string,
        csrfToken: { [key: string]: string }
    ): Promise<ILegacyMigrateResponse>;
}

export class LegacyMigrateUseCase implements ILegacyMigrateUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        payload: ILegacyMigrateRequest,
        authToken: string,
        authSign: string,
        csrfToken: { [key: string]: string }
    ): Promise<ILegacyMigrateResponse> {
        return await this.userRepo.legacyMigrate(payload, authToken, authSign, csrfToken);
    }
}
